import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import KYCStart from "@/pages/KYCStart";
import RewardsStore from "@/pages/RewardsStore";
import AdminDashboard from "@/pages/AdminDashboard";
import DigiLockerCallback from "@/pages/DigiLockerCallback";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kyc/start" element={<KYCStart />} />
          <Route path="/kyc/digilocker-callback" element={<DigiLockerCallback />} />
          <Route path="/rewards" element={<RewardsStore />} />
          <Route path="/rewards/store" element={<RewardsStore />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
